import { useEffect, useState } from 'react'
import { Spin } from 'antd'
import DataTables from './DataTables';
import FilterTanggal from './FilterTanggal';
import ChartEngine1 from './Chart/ChartEngine1';
import ChartEngine2 from './Chart/ChartEngine2';
import ChartFuelLevel from './Chart/ChartFuelLevel';
import { useDataFilter } from '../../components/global.jsx';
import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import ChartInclination from './Chart/ChartInclination.jsx';
import ChartFuelLevel2 from './Chart/ChartFuelLevel2.jsx';
import { HiChartBar, HiFilter, HiLightningBolt, HiCube, HiTable } from 'react-icons/hi';
import ChartLineConsumption from './Chart/ChartLineConsumption.jsx';


const HistoryCal = () => {

    useEffect(() => {
        document.title = "NextSense - History Calibration";
    }, []);

    useDataFilter();

    const getDateTime = () => {
        return dayjs().format('YYYY-MM-DD HH:mm:ss.SSS');
    };

    const getBeforeDateTime = () => {
        return dayjs().subtract(12, 'hour').format('YYYY-MM-DD HH:mm:ss.SSS');
    };

    const [searchParams] = useSearchParams();
    const KodeCabang = searchParams.get("KodeCabang") ? searchParams.get("KodeCabang") : "SGM";
    const ShipCode = searchParams.get("ShipCode") ? searchParams.get("ShipCode") : "G2008";

    const [sensorType, setSensorType] = useState(['All']);
    const sensor = sensorType.join(',');

    const [startDate, setStartDate] = useState(getBeforeDateTime());
    const [endDate, setEndDate] = useState(getDateTime());
    const [TimeRange, setTimeRange] = useState('5');

    const [dataSource, setDataSource] = useState([]);

    const [loadingChart, setLoadingChart] = useState(false);
    const [dataEngine1, setDataEngine1] = useState([]);
    const [dataEngine2, setDataEngine2] = useState([]);
    const [dataFuelLevel, setDataFuelLevel] = useState([]);
    const [dataInclination, setDataInclination] = useState([]);

    const [loadingLvl, setLoadingLvl] = useState(false);
    const [dataLevelConsumption, setDataLevelConsumption] = useState([]);


    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 p-4">
            <div className="space-y-6">
                {/* Header Section */}
                <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                        <div className="flex items-center space-x-4">
                            <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-accent-500 rounded-xl flex items-center justify-center shadow-lg">
                                <HiChartBar className="w-6 h-6 text-white" />
                            </div>
                            <div>
                                <h1 className="text-3xl font-bold gradient-text">Data History</h1>
                                <p className="text-gray-600 mt-1">Historical sensor data and analytics</p>
                            </div>
                        </div>

                        {/* <div className="flex items-center space-x-3">
                            <div className="flex items-center space-x-2 px-4 py-2 bg-blue-50 rounded-xl border border-blue-200">
                                <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                                <span className="text-sm font-semibold text-blue-700">{dataSource.length} Records</span>
                            </div>
                            <div className="flex items-center space-x-2 px-4 py-2 bg-gray-50 rounded-xl border border-gray-200">
                                <HiCalendar className="w-4 h-4 text-gray-500" />
                                <div>
                                    <p className="text-xs text-gray-500 font-medium">Date Range</p>
                                    <p className="text-sm font-semibold text-gray-700">
                                        {dayjs(startDate).format("DD MMM")} - {dayjs(endDate).format("DD MMM YYYY")}
                                    </p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>

                {/* Filter Section */}
                <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                    <div className="flex items-center space-x-3 mb-4">
                        <div className="w-8 h-8 bg-purple-500/20 rounded-lg flex items-center justify-center">
                            <HiFilter className="w-4 h-4 text-purple-600" />
                        </div>
                        <div>
                            <h2 className="text-xl font-semibold text-gray-900">Filter Settings</h2>
                            <p className="text-sm text-gray-600">Configure your data parameters</p>
                        </div>
                    </div>
                    <FilterTanggal
                        dataFilter={(data) => {
                            // Handle loading state
                            if (data.isLoading !== undefined) {
                                setLoadingChart(data.isLoading);
                                setLoadingLvl(data.isLoading);
                            }

                            // Set filter parameters
                            if (data.filterParams) {
                                setSensorType(data.filterParams.sensor);
                                setStartDate(data.filterParams.startDate);
                                setEndDate(data.filterParams.endDate);
                                setTimeRange(data.filterParams.TimeRange);
                            }

                            // Set processed data
                            if (data.dataSource) {
                                setDataSource(data.dataSource);
                                setDataEngine1(data.dataEngine1 || []);
                                setDataEngine2(data.dataEngine2 || []);
                                setDataFuelLevel(data.dataFuelLevel || []);
                                setDataInclination(data.dataInclination || []);
                                setDataLevelConsumption(data.dataLevelConsumption || []);
                            }
                        }}
                        accountName={KodeCabang}
                        sensorName={sensorType ? sensorType : ['All']}
                        startRanges={startDate}
                        endRanges={endDate}
                        TimesRanges={TimeRange}
                    />
                </div>

                {/* Charts Section */}
                <div className="space-y-6">
                    {/* Engine Charts */}
                    {dataEngine1.length > 0 && (
                        <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                            <div className="flex items-center space-x-3 mb-4">
                                <div className="w-8 h-8 bg-red-500/20 rounded-lg flex items-center justify-center">
                                    <HiLightningBolt className="w-4 h-4 text-red-600" />
                                </div>
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900">Engine 1</h3>
                                    <p className="text-sm text-gray-600">RPM and temperature data</p>
                                </div>
                            </div>
                            {loadingChart ? (
                                <div className="flex justify-center items-center h-64">
                                    <Spin tip="Loading chart...">
                                        <ChartEngine1 DataSource={dataEngine1} />
                                    </Spin>
                                </div>
                            ) : (
                                <ChartEngine1 DataSource={dataEngine1} />
                            )}
                        </div>
                    )}

                    {dataEngine2.length > 0 && (
                        <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                            <div className="flex items-center space-x-3 mb-4">
                                <div className="w-8 h-8 bg-orange-500/20 rounded-lg flex items-center justify-center">
                                    <HiLightningBolt className="w-4 h-4 text-orange-600" />
                                </div>
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900">Engine 2</h3>
                                    <p className="text-sm text-gray-600">RPM and temperature data</p>
                                </div>
                            </div>
                            {loadingChart ? (
                                <div className="flex justify-center items-center h-64">
                                    <Spin tip="Loading chart...">
                                        <ChartEngine2 DataSource={dataEngine2} />
                                    </Spin>
                                </div>
                            ) : (
                                <ChartEngine2 DataSource={dataEngine2} />
                            )}
                        </div>
                    )}

                    {/* Fuel Level Charts */}
                    {dataFuelLevel.length > 0 && (
                        <>
                            <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                                <div className="flex items-center space-x-3 mb-4">
                                    <div className="w-8 h-8 bg-blue-500/20 rounded-lg flex items-center justify-center">
                                        <HiCube className="w-4 h-4 text-blue-600" />
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-900">Fuel Level (cm)</h3>
                                        <p className="text-sm text-gray-600">Tank capacity monitoring</p>
                                    </div>
                                </div>
                                {loadingChart ? (
                                    <div className="flex justify-center items-center h-64">
                                        <Spin tip="Loading chart...">
                                            <ChartFuelLevel DataSource={dataFuelLevel} />
                                        </Spin>
                                    </div>
                                ) : (
                                    <ChartFuelLevel DataSource={dataFuelLevel} />
                                )}
                            </div>

                            <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                                <div className="flex items-center space-x-3 mb-4">
                                    <div className="w-8 h-8 bg-cyan-500/20 rounded-lg flex items-center justify-center">
                                        <HiCube className="w-4 h-4 text-cyan-600" />
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-900">Fuel Level (Volume)</h3>
                                        <p className="text-sm text-gray-600">Secondary tank monitoring</p>
                                    </div>
                                </div>
                                {loadingChart ? (
                                    <div className="flex justify-center items-center h-64">
                                        <Spin tip="Loading chart...">
                                            <ChartFuelLevel2 DataSource={dataFuelLevel} />
                                        </Spin>
                                    </div>
                                ) : (
                                    <ChartFuelLevel2 DataSource={dataFuelLevel} />
                                )}
                            </div>
                        </>
                    )}

                    {/* Inclination Chart */}
                    {dataInclination.length > 0 && (
                        <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                            <div className="flex items-center space-x-3 mb-4">
                                <div className="w-8 h-8 bg-purple-500/20 rounded-lg flex items-center justify-center">
                                    <HiCube className="w-4 h-4 text-purple-600" />
                                </div>
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900">Inclination</h3>
                                    <p className="text-sm text-gray-600">Vessel stability monitoring</p>
                                </div>
                            </div>
                            {loadingChart ? (
                                <div className="flex justify-center items-center h-64">
                                    <Spin tip="Loading chart...">
                                        <ChartInclination DataSource={dataInclination} />
                                    </Spin>
                                </div>
                            ) : (
                                <ChartInclination DataSource={dataInclination} />
                            )}
                        </div>
                    )}

                    {/* Level Consumption Charts */}
                    {dataLevelConsumption.length > 0 && (
                        <>
                            <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                                <div className="flex items-center space-x-3 mb-4">
                                    <div className="w-8 h-8 bg-green-500/20 rounded-lg flex items-center justify-center">
                                        <HiCube className="w-4 h-4 text-green-600" />
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-900">Consumption Trend</h3>
                                        <p className="text-sm text-gray-600">Fuel consumption analysis</p>
                                    </div>
                                </div>
                                {loadingLvl ? (
                                    <div className="flex justify-center items-center h-64">
                                        <Spin tip="Loading chart...">
                                            <ChartLineConsumption DataSource={dataLevelConsumption} />
                                        </Spin>
                                    </div>
                                ) : (
                                    <ChartLineConsumption DataSource={dataLevelConsumption} />
                                )}
                            </div>

                            {/* <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                                <div className="flex items-center space-x-3 mb-4">
                                    <div className="w-8 h-8 bg-teal-500/20 rounded-lg flex items-center justify-center">
                                        <HiCube className="w-4 h-4 text-teal-600" />
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-900">Consumption Detail</h3>
                                        <p className="text-sm text-gray-600">Detailed consumption metrics</p>
                                    </div>
                                </div>
                                {isLoading ? (
                                    <div className="flex justify-center items-center h-64">
                                        <Spin tip="Loading chart...">
                                            <ChartLine2 DataSource={dataLevelConsumption} displayNo={20} />
                                        </Spin>
                                    </div>
                                ) : (
                                    <ChartLine2 DataSource={dataLevelConsumption} displayNo={20} />
                                )}
                            </div> */}
                        </>
                    )}
                </div>

                {/* Data Table Section */}
                <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                    <div className="flex items-center space-x-3 mb-6">
                        <div className="w-8 h-8 bg-gray-500/20 rounded-lg flex items-center justify-center">
                            <HiTable className="w-4 h-4 text-gray-600" />
                        </div>
                        <div>
                            <h3 className="text-lg font-semibold text-gray-900">Data Table</h3>
                            <p className="text-sm text-gray-600">Complete historical records</p>
                        </div>
                    </div>
                    {loadingChart ? (
                        <div className="flex justify-center items-center py-12">
                            <Spin tip="Loading data table..." size="large">
                                <DataTables DataSource={dataSource} />
                            </Spin>
                        </div>
                    ) : (
                        <DataTables DataSource={dataSource} />
                    )}
                </div>
            </div>
        </div>
    )
}

export default HistoryCal